import { useCallback, useEffect, useRef, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'
import { getTranslatedText } from 'partner360/helpers/getTranslatedText'

import { ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS } from '../translations'

import styles from './AcknowledgmentCopyEmailButton.module.scss'

const KEYS = ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS.common

const COPIED_FEEDBACK_MS = 1500

type AcknowledgmentCopyEmailButtonProps = {
  email: string
}

export const AcknowledgmentCopyEmailButton = ({ email }: AcknowledgmentCopyEmailButtonProps) => {
  const t = useSafetyTranslation()
  const [isCopied, setIsCopied] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => () => clearTimeout(timeoutRef.current), [])

  const handleCopy = useCallback(async () => {
    await navigator.clipboard.writeText(email)
    setIsCopied(true)
    clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => setIsCopied(false), COPIED_FEEDBACK_MS)
  }, [email])

  return (
    <Tooltip
      tipContent={() => <Translation span text={isCopied ? KEYS.emailCopied : KEYS.copyEmail} />}
    >
      <Button
        className={styles.button}
        variant="text"
        size="sm"
        iconButton="kbase kbase-copy"
        aria-label={getTranslatedText({ t, key: KEYS.copyEmail })}
        onClick={() => void handleCopy()}
      />
    </Tooltip>
  )
}
